import Button from '../Button/Button';
import './booking-select-credit-card.scss';
import ButtonEnum from '../Button/ButtonEnum';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
  useCreditCards,
  useFetchCreditCards,
  useSetSaveCreditCard,
  useSetSelectedCreditCard,
} from '../../../store/creditCards/creditCardsHooks';
import CreditCard from '../../pages/account-settings/CreditCard';
import { CreditCardType } from '../../../store/creditCards/creditCardsTypes';
import AddNewCreditCardComponent from '../../pages/account-settings/AddNewCreditCardComponent';

interface BookingSelectCreditCardProps {
  onClickSelectCreditCard: () => void;
  onClickSelectNewCreditCard: (rememberCard: boolean) => void;
  onClickBack: () => void;
}

const BookingSelectCreditCard = (props: BookingSelectCreditCardProps) => {
  const { t } = useTranslation();
  const creditCards = useCreditCards();
  const fetchCreditCards = useFetchCreditCards();
  const selectCreditCard = useSetSelectedCreditCard();
  const setSaveCreditCard = useSetSaveCreditCard();

  const [saveCard, setSaveCard] = useState(true);

  useEffect(() => {
    fetchCreditCards().finally();
  }, []);

  const onClickSelectCreditCard = (creditCard: CreditCardType) => {
    selectCreditCard(creditCard);
    props.onClickSelectCreditCard();
  };

  return (
    <div className="booking-select-credit-card">
      <div className="booking-select-credit-card-title">
        {t('SELECT_CREDIT_CARD_TEXT')}
      </div>
      <div className="credit-card-items">
        <div className="credit-card-item">
          <AddNewCreditCardComponent
            saveCardValue={saveCard}
            onChangeSaveCard={setSaveCard}
            onClick={() => {
              setSaveCreditCard(saveCard);
              props.onClickSelectNewCreditCard(true);
            }}
          />
        </div>
        {creditCards.map((card) => (
          <div
            className="credit-card-item"
            key={card.id}
            onClick={() => onClickSelectCreditCard(card)}
          >
            <CreditCard
              brand={card.brand}
              suffix={card.suffix}
              expiration={card.expiration}
              hideRemoveButton
            />
          </div>
        ))}
      </div>
      <Button
        className="bocking-select-credit-back-button"
        type={ButtonEnum.GREY_LIGHT}
        onClick={props.onClickBack}
        text={t('CLOSE_BUTTON')}
      />
    </div>
  );
};

export default BookingSelectCreditCard;
